import AppUser from '../records/AppUser';
import { FetchAppUserActionTypes } from '../actions/AppUserActions';
const defaultState = new AppUser();
const appUser = (state = defaultState, action) => {
  switch (action.type) {
    case FetchAppUserActionTypes.SUCCESS:
      return new AppUser(action.payload.data);
    default:
      return state;
  }
};
export default appUser;